import React, { Component } from 'react';

import './UnorderedList.module.css';

class UnorderedList extends Component {
  render() {
    const childrenText = this.props.children.map(child => child.props.children);
    return (
      <ul styleName="unordered-list">
        {childrenText.map((li, i) => (
          <li key={i} styleName="unordereditem">
            {li}
          </li>
        ))}
      </ul>
    );
  }
}

UnorderedList.propTypes = {
  /** The list items to be displayed */
};

export default UnorderedList;
